import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1df58f49"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper d-flex flex-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-x-0 -top-40 z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80",
  "aria-hidden": "true",
  style: {"pointer-events":"none"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]",
    style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
  })
], -1))

import { ref } from "vue";
  import LeftSideBlock from "@/views/components/auth/LeftSideBlock.vue";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

  const isSignUp = ref(true);
  const isPrivacyPolicy = ref(false)
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(LeftSideBlock)
  ]))
}
}

})